import qs from 'qs'

import deleteEmptyKeys from '@/src/shared/lib/deleteEpmtyKeys'

export type JSONValue =
  | string
  | number
  | boolean
  | Date
  | { [x: string]: JSONValue }
  | Array<JSONValue>
export type IQuery = Record<string, unknown>

const logger = {
  info: (url: string) => console.info(`Request to: ${url}`),
  error: (url: string) => console.error(`Request to: ${url}`),
}

export const get = (url: string) => {
  return async (query: IQuery = {}) => {
    const param = query.slug
    const hasParam = !!param

    const queryStringified = qs.stringify(deleteEmptyKeys(query))
    const hasQuery = !!queryStringified

    const urlWithParam = hasParam ? `${url}/${param}` : null
    const urlWithQuery = hasQuery ? `${url}?${queryStringified}` : url

    const fullUrl = urlWithParam ?? urlWithQuery

    try {
      const data = await fetch(fullUrl, {
        headers: { 'X-Accept-Language': query?.locale as string }, // Forward the authorization header
      }).then((res) => res.json())

      // logger.info(fullUrl)

      return data as Promise<JSONValue>
    } catch (err) {
      if (err instanceof Error) {
        logger.error(fullUrl)

        throw new Error(err.message)
      }

      logger.error(fullUrl)

      throw err
    }
  }
}
export const post = (url: string) => {
  return async (data: IQuery = {}) => {
    try {
      // Default options are marked with *
      const response = await fetch(url, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Accept-Language': data?.locale as string,
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // no-referrer, *client
        body: JSON.stringify(data || {}), // body data type must match "Content-Type" header
      })

      // logger.info(url)

      return await response.json() // parses JSON response into native JavaScript objects
    } catch (err) {
      if (err instanceof Error) {
        logger.error(url)

        throw new Error(err.message)
      }

      logger.error(url)

      throw err
    }
  }
}
